module.exports = __webpack_public_path__ + "static/media/EastEndCemetery_white.33604b3e.png";


//////////////////
// WEBPACK FOOTER
// ./src/EastEndCemetery_white.png
// module id = 239
// module chunks = 0